import Api from "../../../api/index";

const Round = {
  namespaced: true,
  state: {
    allRounds: null,
    oneRoundGames: null
  },

  mutations: {
    setAllRounds(state, payload) {
      state.allRounds = payload;
    },
    setOneRoundGames(state, payload) {
      state.oneRoundGames = payload;
    }
  },

  actions: {
    // index(context, championship_id) {
    //   return Api.Championship.indexRounds(championship_id)
    //     .then(r => r.data)
    //     .then(data => {
    //       context.commit("setAllRounds", data);
    //     });
    // },
    // update(context, { champTeam }) {
    //   return Api.Championship.updateRound(champTeam)
    //     .then(response => response.data)
    //     .then(team => {})
    //     .catch(error => {
    //       console.log({ error });
    //     });
    // }
  }
};

export default Round;
